module.exports = __webpack_public_path__ + "img/bubble_chart.c81afa12.svg";